module.exports = __webpack_public_path__ + "static/media/bacon-egger-mobile-250-fr.948b3cf4.jpg";